module.exports = __webpack_public_path__ + "static/img/banner-4.d3ab471.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-4.png
// module id = P7kY
// module chunks = 0